import useGetAppointmentPayments from '../../hooks/appointments/useGetAppointmentPayments';
import { PaymentWithTransfers } from '../../types/payments';
import TransfersDetails from '../transactions/TransfersDetails';
import { Appointment } from '../../interfaces';

interface Props {
  appointment: Appointment;
  payment?: PaymentWithTransfers;
}

function AppointmentTransfersSection({ payment, appointment }: Props) {
  const { payments, isFetching } = useGetAppointmentPayments(appointment, {
    enabled: !payment,
  });

  const filteredPayments = payment ? [payment] : payments;

  return (
    <TransfersDetails
      payments={filteredPayments ?? []}
      isLoading={isFetching}
    />
  );
}

export default AppointmentTransfersSection;
